export const excludedPages = ['/password-generator/', '/password-strength/']
